import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Blogs from "../views/Blogs.vue";
import Login from "../views/Login.vue";
import Register from "../views/Register.vue";
import ForgotPassword from "../views/ForgotPassword.vue";
import Profile from "../views/Profile.vue";
import Admin from "../views/Admin.vue";
import CreatePost from "../views/CreatePost.vue";
import BlogPreview from "../views/BlogPreview.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "الرئيسيه",
    },
  },
  {
    path: "/blogs",
    name: "Blogs",
    component: Blogs,
    meta: {
      title: "المنشورات",
    },
  },
  {
    path: "/create",
    name: "CreatePost",
    component: CreatePost,
    meta: {
      title: "اكتب منشور",
    },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      title: "تسجيل الدخول",
    },
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
    meta: {
      title: "انشاء الحساب",
    },
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPassword,
    meta: {
      title: "نسيت كلمة المرور",
    },
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: {
      title: "الملف الشخصي",
    },
  },
  {
    path: "/admin",
    name: "Admin",
    component: Admin,
    meta: {
      title: "الأدمن",
    },
  },
  {
    path: "/post-preview",
    name: "PostPreview",
    component: BlogPreview,
    meta: {
      title: "عرض المنشور",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = `مدونة الرؤي | ${to.meta.title} `;
  next();
});
export default router;
